import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from "../baseQuery";
import { createPriceType, listPriceType } from "../../graphql";

export const priceTypeApi = createApi({
    reducerPath: 'PriceTypeApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listPriceTypes: builder.query({
            query: (variables) => ({ body: listPriceType, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: ['getPaymentSettings'],
        }),
        createPriceType: builder.mutation({
            query: (variables) => ({ body: createPriceType, variables }),
            invalidatesTags: ['getPaymentSettings'],
        }),
    })
});
export const { useCreatePriceTypeMutation, useListPriceTypesQuery } = priceTypeApi;